const mutationTypes = {
  SET_SELECTED_LICENSE: 'setSelectedLicense'
};

const state = {
  selectedLicense: null
};

const mutations = {
  [mutationTypes.SET_SELECTED_LICENSE]: (state, license) => state.selectedLicense = license
};

const actions = {
  setSelectedLicense: ({commit}, license) => {
    commit(mutationTypes.SET_SELECTED_LICENSE, license);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
